// extracted by mini-css-extract-plugin
export default {"contactUs":"ContactUs_contactUs__2P0+Z","mobileName":"ContactUs_mobileName__oVzAf"};